import workOrder from './work-order'
import requisition from './requisition'
import news from './news'

export default {
  // 用户登入后，获取菜单权限树
  afterLogin: 'backend.org.ums.permission.listMenuTree.afterLogin',

  // 更换密码
  password: 'backend.org.ums.change.password',

  // 获取更换密码的短信验证码
  code: 'backend.org.ums.change.password.get.code',

  // 引用工单模板api
  workOrder,

  // 引入工单申请模块
  requisition,

  // 引入消息模块
  news
}
